import styled from 'styled-components'

export const LiveSessionPg = styled.div`
  min-height: calc(100vh - 150px);
  width: 100%;
  padding: 0 20px 20px 20px;
  color: rgb(210, 210, 210);
  margin-left: 20px;

  @media only screen and (max-width: 600px) {
    margin-left: 0;
  }

  .heading {
    text-shadow: 0px 3px 5px #000000;
    color: #e32752;
    margin-bottom: 1em;
  }

  .session-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 40px;
    grid-row-gap: 50px;
    justify-content: center;

    .placeholder {
      height: 280px;
    }

    @media only screen and (max-width: 600px) {
      margin-top: 20px;
      grid-template-columns: 1fr;
    }
  }
`

export const LiveSessionAccessPg = styled.div`
  min-height: calc(100vh - 150px);
  background-color: black;
  padding-top: 50px;
  padding-left: 150px;
  padding-right: 150px;
  padding-bottom: 50px;
  text-align: left;
  position: relative;

  @media only screen and (max-width: 600px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  h3 {
    font-size: 1.1em;
    text-align: left;
    font-weight: 800;
    color: rgb(210, 210, 210);
  }

  .top-graphic {
    width: 100%;
  }

  h1 {
    color: rgb(210, 210, 210);
    font-size: 3em;
    font-weight: 700;
  }
  h2 {
    color: rgb(210, 210, 210);
  }

  .zoom-btn {
    border-radius: 10px;
    border: none;
    outline: none;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.9em;
    background-color: rgb(206, 60, 85);
    color: white;
  }

  .zoom-btn:focus,
  .zoom-btn:active {
    outline: none;
    box-shadow: none;
  }

  .next-sessions {
    margin-top: 50px;
  }

  .up-next {
    display: flex;
    align-items: center;

    svg {
      fill: rgb(82, 171, 214) !important;
    }

    h3 {
      margin-left: 20px;
      font-size: 1.6em;
      font-weight: 600;
    }
  }

  .upcoming-sessions {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .bottom-graphic {
    position: absolute;
    bottom: 0px;
    right: 0px;
  }

  .synopsis {
    font-weight: 700;
  }
`

export const NextSessionCard = styled.div`
  width: 250px;
  height: 300px;
  max-height: 300px;
  position: relative;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 20px;
  padding-bottom: 50px;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  background-color: black;

  img {
    border-radius: 20px;
    object-fit: cover;
  }

  .gradient {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: linear-gradient(
      transparent,
      transparent,
      transparent,
      transparent,
      rgba(0, 0, 0, 0.8),
      rgba(0, 0, 0, 1)
    );
    border-radius: 20px;
  }

  .text-box {
    width: 100%;
    padding-left: 10px;
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -20%);
    padding-top: 10px;
    color: white;
    text-align: center;
    /* height: 100%; */
    display: flex;
    flex-direction: column;

    .title {
      font-size: 0.7em;

      font-weight: 600;
    }

    .name {
      font-size: 0.7em;
    }
  }
`
